import type { RouteObject } from 'react-router-dom'
import { Outlet } from 'react-router-dom'

import AmplitudeEventTaxonomy from '@app/pages/superAdmin/amplitudeEventTaxonomy'

const routes: RouteObject = {
  path: '/',
  element: <Outlet />,
  children: [
    {
      path: 'amplitude-event-taxonomy',
      element: <AmplitudeEventTaxonomy />
    }
  ]
}

export default routes
